module.exports = __webpack_public_path__ + "static/media/aas.f321131a.svg";